import { useState } from "react";
import { Alert, Box, Button, Drawer, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import Sidebar from "../scenes/global/Sidebar";
import Topbar from "../scenes/global/Topbar";
import saasApi from "../utils/saasApi";

const AppShell = ({ children, user, role, onLogout, background }) => {
  const location = useLocation();
  const theme = useTheme();
  const { t } = useTranslation();
  const desktop = useMediaQuery(theme.breakpoints.up("lg"));
  const [navigationOpen, setNavigationOpen] = useState(false);
  const isVigilante = role === "vigilante";
  const isVideoWall = location.pathname === "/monitoring/video-wall" || location.pathname === "/video-wall";
  const impersonationClient = sessionStorage.getItem("impersonation_client");
  const isImpersonating = Boolean(sessionStorage.getItem("superadmin_token") && impersonationClient);
  const returnToSuperadmin = async () => {
    const sessionId = sessionStorage.getItem("impersonation_session_id");
    const superadminToken = sessionStorage.getItem("superadmin_token");
    const superadminUser = sessionStorage.getItem("superadmin_user");
    const superadminRole = sessionStorage.getItem("superadmin_role") || "superadmin";
    if (superadminToken) localStorage.setItem("token", superadminToken);
    if (superadminUser) localStorage.setItem("user", superadminUser);
    localStorage.setItem("role", superadminRole);
    sessionStorage.removeItem("superadmin_token");
    sessionStorage.removeItem("superadmin_user");
    sessionStorage.removeItem("superadmin_role");
    sessionStorage.removeItem("impersonation_client");
    sessionStorage.removeItem("impersonation_session_id");
    if (sessionId) saasApi.endImpersonation({ impersonation_session_id: Number(sessionId) }).catch(() => {});
    window.location.assign("/superadmin");
  };

  return (
    <Box className="dashboard-shell">
      <div className={`app${isVideoWall || isVigilante ? " app-standalone" : ""}`}>
        {!isVigilante && !isVideoWall && (
          <Drawer variant={desktop ? "permanent" : "temporary"} open={desktop || navigationOpen} onClose={() => setNavigationOpen(false)} ModalProps={{ keepMounted: true }} sx={{ flexShrink: 0, "& .MuiDrawer-paper": { position: desktop ? "sticky" : "fixed", top: desktop ? 24 : 0, height: desktop ? "calc(100vh - 48px)" : "100%", overflowX: "hidden", border: 0, background: desktop ? "transparent" : theme.custom.surface.inset, px: desktop ? 0 : 2, py: desktop ? 0 : 2 } }}>
            <Sidebar user={user} role={role} compactAllowed={desktop} onNavigate={() => setNavigationOpen(false)} />
          </Drawer>
        )}
        <main className="content" style={{ background: isVideoWall || isVigilante ? background : "transparent" }}>
          {isImpersonating && !isVideoWall && (
            <Alert severity="warning" sx={{ mb: 2 }} action={<Button color="inherit" size="small" onClick={returnToSuperadmin}>Volver a Superadmin</Button>}>
              Estas viendo Absolluty como {impersonationClient}
            </Alert>
          )}
          {!isVideoWall && <Topbar user={user} role={role} onLogout={onLogout} onOpenNavigation={!desktop && !isVigilante ? () => setNavigationOpen(true) : undefined} />}
          <Box sx={{ minHeight: "100%" }}>{children}</Box>
        </main>
      </div>
      {!isVigilante && !isVideoWall && <Box component="footer" sx={{ mx: { xs: 2, md: 3.5 }, py: 1.75, borderTop: "1px solid", borderColor: "divider", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
        <Box display="flex" alignItems="center" gap={1}><Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "primary.main" }} /><Typography variant="caption" color="text.secondary">Absolluty · {t("platform.brand.subtitle")}</Typography></Box>
        <Typography variant="caption" color="text.secondary" sx={{ fontFamily: theme.custom.monoFont }}>{Intl.DateTimeFormat().resolvedOptions().timeZone}</Typography>
      </Box>}
    </Box>
  );
};

export default AppShell;
